<template>
  <el-card
    class="card-container"
    shadow="never"
  >
    <CardHeader
      slot="header"
      title="Danh sách các trường dữ liệu"
      :total="total"
      :is-edit="isEdit"
      :new-fields="newFields"
      @edit="handleEdit"
      @create="handleCreate"
      @save="handleSave"
    />
    <CardFilter
      :type-key="typeKey"
      :group-key="groupKey"
      :groups="groups"
      :object="object"
      @search="handleSearch"
    />
    <CardList
      :data="paginationFields"
      :loading="false"
      :groups="groups"
      :is-edit="isEdit"
      @edit="handleUpdate"
      @delete="handleDelete"
    />
    <el-row
      type="flex"
      align="middle"
      justify="end"
      class="mt-l"
    >
      <el-pagination
        background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleChangePageSize"
        @current-change="handleChangePage"
      />
    </el-row>
    <FieldFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :object="object"
      :all-configs="allConfigs"
      @close="formVisible = false"
      @save="handleSave"
    />
  </el-card>
</template>

<script>
import CardHeader from "./object-fields/CardHeader.vue";
import CardFilter from "./object-fields/CardFilter.vue";
import CardList from "./object-fields/CardList.vue";
import FieldFormPopup from "../../popups/FieldForm.vue";

import { notification } from "@/utils/common";

export default {
  name: "ObjectFields",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    FieldFormPopup,
  },
  props: {
    object: Object,
    allConfigs: Array,
  },
  data() {
    return {
      searchText: "",
      typeKey: "",
      groupKey: "",
      page: 1,
      pageSize: 10,
      selectedItem: null,
      formVisible: false,
      isEdit: false,
      newFields: []
    };
  },
  computed: {
    groups() {
      return this.object?.extra?.groups || [];
    },
    selectedGroup() {
      return this.groups.find((g) => g.key === this.groupKey);
    },
    fields() {
      const data = this.object?.extra?.fields || [];
      return data;
    },
    total() {
      return this.filteredFields.length;
    },
    filteredFields() {
      return this.newFields
        .filter((d) => {
          if (this.searchText?.trim()) {
            return (
              d.key.includes(this.searchText.toLowerCase()) ||
              d.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
          }
          return true;
        })
        .filter((f) => {
          if (this.selectedGroup) {
            return this.selectedGroup.fields.includes(f.key)
          }
          return true;
        })
        .filter((f) => (this.typeKey ? f.type === this.typeKey : true));
    },
    paginationFields() {
      const result = this.filteredFields;
      return result
        .sort((a, b) => a.order - b.order)
        .slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    },
  },
  beforeMount() {
    this.newFields = JSON.parse(JSON.stringify(this.object?.extra?.fields || []));
  },
  methods: {
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleEdit(value) {
      this.isEdit = value;
      this.newFields = JSON.parse(JSON.stringify(this.fields))
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        const fields = this.fields.filter((f) => f.key !== item.key);
        this.handleSave({
          payload: { fields },
          success: () => {
            notification(this, "success", "delete", `trường dữ liệu`);
          },
          error: () => {
            notification(this, "error", "delete", "trường dữ liệu");
          },
        });
      });
    },
    handleSearch(payload) {
      this.page = 1;
      this.typeKey = payload.type;
      this.groupKey = payload.group;
      this.searchText = payload.searchText;
    },
    handleChangePage(page) {
      this.page = page;
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
    },
    handleSave(
      data = { payload: {}, success: () => {}, error: () => {} },
      callback = () => {}
    ) {
      this.$emit('save', data, callback)
    },
  },
};
</script>

<style lang="scss" scoped></style>
